<template>
  <div>
    <nav class="level is-mobile lxm-menu">
      <p class="level-item has-text-left lxm-menu__title">
        {{ teamName }}
      </p>
      <p class="level-item has-text-right lxm-menu__button" @click="buttonClick">
        <img src="../../images/main/menu.png">
      </p>
    </nav>
    <div class="lxm-menu-placeholder"></div>
    <lxm-menu-panel ref="menuPanel"></lxm-menu-panel>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  menu-height = 3.93rem
  .lxm-menu
    background: gradient
    height: menu-height
    position: fixed
    width: 100vw
    z-index: 1
  .lxm-menu__title
    color: white
    padding-left: siz(15)
    font-size: siz(15)
  .lxm-menu__button
    padding-right: siz(15)
    img
      width: siz(22)
  .lxm-menu-placeholder
    height: menu-height
</style>

<script>
  import LxmMenuPanel from './LxmMenuPanel.vue'
  export default {
    components: {
      LxmMenuPanel
    },
    data () {
      return {
      }
    },
    computed: {
      teamName () {
        return this.$store.state.user.team.name
      }
    },
    methods: {
      buttonClick () {
        this.$refs.menuPanel.show()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmMenu.vue?7be96bc3